"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAlpha;
var _utils = require("../utils");
var _lib = require("../lib");
var _constants = require("../constants");
function isAlpha(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message;
  var validRegex = new RegExp(options.validRegex || _constants.RX_ALPHA, 'i');
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !validRegex.test(value)) {
    var label = options.label || 'Field';
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      validRegex: validRegex
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " should only has alphabets only"));
  }
  return validity;
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/validations/isAlpha.js
// module id = 1890
// module chunks = 0